import Table, { TableBar } from "../common/Table";
import Button from "../common/Button";

function ContractActive({ store }) {
  const contracts = store.state.contracts && store.state.contracts.filter(e => e.accepted && !e.fulfilled);
  
  return (
    <>
      {contracts.length > 0 
      ? (
        <Table $style="striped">
        <thead>
          <tr>
            <th>Symbol</th>
            <th>Destination</th>
            <th>Complete</th>
          </tr>
        </thead>
        <tbody>
          {contracts.map(contract => (
            contract.terms.deliver.map((item, idx) => (
              <tr key={idx}>
                <td>{item.tradeSymbol}</td>
                <td>{item.destinationSymbol}</td>
                <td>
                  <TableBar title={`${item.unitsFulfilled}/${item.unitsRequired}`} $current={item.unitsFulfilled} $max={item.unitsRequired} />
                </td>
              </tr>
            ))
          ))}
        </tbody>
      </Table>
      )
      : (
        <Button onClick={() => store.setModal('contracts')}>Show contracts</Button>
      )
      }
    </>

  )
}

export default ContractActive;